import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useDebounceKeyword } from '@/app/about/_hooks/useDebounceKeyword';
import type { EstateInfoItemTypes } from '@/app/about/_types/inquiryTypes';
import { searchEstateApi } from '@/lib/about/inquiryApi';
import type { InquirySearchTypes } from '@/lib/about/inquiryApiTypes';
export default function SearchEstate(t0) {
  const $ = _c(31);
  const {
    keyword,
    setKeyword,
    setFormData,
    formData
  } = t0;
  const [searchActive, setSearchActive] = useState(true);
  const debounceKeyword = useDebounceKeyword(keyword);
  let t1;
  let t2;
  if ($[0] !== debounceKeyword) {
    t1 = ["searchCompany", debounceKeyword];
    t2 = () => searchEstateApi({
      keyword: debounceKeyword
    });
    $[0] = debounceKeyword;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  const t3 = debounceKeyword.length > 1;
  let t4;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      queryKey: t1,
      queryFn: t2,
      placeholderData: keepPreviousData,
      enabled: t3
    };
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: searchResult
  } = useQuery(t4);
  let t5;
  if ($[7] !== setFormData || $[8] !== setKeyword) {
    t5 = item => {
      setKeyword(item.bsnmCmpnm);
      setFormData(prev => ({
        ...prev,
        agencyNm: item.bsnmCmpnm,
        brokerNm: item.brkrNm,
        brokerPosition: item.ofcpsSeCodeNm === "\uB300\uD45C" ? item.ofcpsSeCodeNm : item.brkrAsortCodeNm,
        roadAddr: item.ldCodeNm,
        openRegNo: item.jurirno
      }));
      setSearchActive(false);
    };
    $[7] = setFormData;
    $[8] = setKeyword;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const selectedEstate = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setSearchActive(false);
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const noDataHide = t6;
  let t7;
  if ($[11] !== setKeyword) {
    t7 = e => {
      setKeyword(e.target.value);
      setSearchActive(true);
    };
    $[11] = setKeyword;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = searchResult && noDataHide;
  const t9 = formData.preOpen === "Y";
  let t10;
  if ($[13] !== keyword || $[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <input id="inquiryName" type="text" placeholder={"\uB300\uD45C, \uC18C\uC18D\uACF5\uC778\uC911\uAC1C\uC0AC, \uC911\uAC1C\uBCF4\uC870\uC6D0\uC758 \uC131\uBA85"} value={keyword} onChange={t7} onBlur={t8} disabled={t9} autoComplete="off" />;
    $[13] = keyword;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== searchActive || $[19] !== searchResult || $[20] !== selectedEstate) {
    t11 = searchResult && searchActive && <div className="search_result">{searchResult.data.field.length === 0 && <div className="no_data">검색되는 정보가 없습니다</div>}<ul className="list_estate">{searchResult.data.field.map((item_0, index) => <li key={`${item_0.jurirno}-${index}`}><button type="button" onMouseDown={() => selectedEstate(item_0)}><div className="main_info">{item_0.bsnmCmpnm} ({item_0.brkrNm}{" "}{item_0.ofcpsSeCodeNm == "\uB300\uD45C" ? item_0.ofcpsSeCodeNm : item_0.brkrAsortCodeNm})</div><span className="sub_info"><address>{item_0.ldCodeNm}</address> ({item_0.jurirno})</span></button></li>)}</ul></div>;
    $[18] = searchActive;
    $[19] = searchResult;
    $[20] = selectedEstate;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== formData.brokerNm || $[23] !== formData.brokerPosition || $[24] !== formData.openRegNo || $[25] !== formData.roadAddr) {
    t12 = formData?.openRegNo && <ul className="user_info"><li>주소 : {formData.roadAddr}</li><li>등록번호 : {formData.openRegNo}</li><li>중개사명 : {formData.brokerNm} {formData.brokerPosition}</li></ul>;
    $[22] = formData.brokerNm;
    $[23] = formData.brokerPosition;
    $[24] = formData.openRegNo;
    $[25] = formData.roadAddr;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t10 || $[28] !== t11 || $[29] !== t12) {
    t13 = <div className="wrap_search">{t10}{t11}{t12}</div>;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}